<template>
  <div class="home-layout">
    <section class="center-container flex-center has-gradient">
      <img src="../assets/hero_left_artwork.png"
           alt="floral artwork"
           class="center-container__left-figure" />
      <div class="center-container__content">
        <img src="../assets/bb_logo.png"
             alt="Berries and Bloom Logo"
             class="center-container__logo" />
        <h1 class="center-container__title">
          <em>Berries and Blooms Company</em>
        </h1>
        <p class="center-container__intro-text">
          <em>Is a full service floral and decor company working in and around
          Cape Town. We have a passion for designing unique and beautiful
          creations by using different textures, colours and styles. Berries and
          Blooms is where flowers are our inspiration to create lasting memories.</em>
        </p>
      </div>
      <img src="../assets/hero_right_artwork.png"
           alt="floral artwork"
           class="center-container__right-figure" />
    </section>
    <section class="home-image-links">
      <ul class="flex-inline-list">
        <li v-for="(item, index) in homeImageLinks"
            :key="index"
            :class="item.className">
          <router-link :to="item.link"
                       data-FadeInBottom-stagger
                       :title="item.title">
            <h2 class="home-image-links__label">{{ item.title }}</h2>
          </router-link>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
export default {
  name: 'home',
  data: () => ({
    homeImageLinks: [
      { title: 'Floral Design', link: '/floral-design', className: 'floral-block' },
      { title: 'Decor Hire', link: '/decor-hire', className: 'decor-block' },
      { title: 'Get In Touch', link: '/get-in-touch', className: 'contact-block' },
    ],
  }),
  metaInfo: {
    title: 'Berries And Blooms - Full Service Floral and Decor Company',
    links: [
      { rel: 'canonical', href: 'http://berriesandblooms.co.za/' },
      { rel: 'alternate', href: 'http://berriesandblooms.co.za/', hreflang: 'en-us' },
    ],
  },
}
</script>

<style lang="scss">
  .home-layout {
    position: relative;
  }
</style>
